<app-header/>
<ion-content>
    <div class="main-container overviewContainer">
        @if (!isLoadingPage) {
            <ion-grid class="filterSection">
                <form [formGroup]="filterForm" (ngSubmit)="filter()">
                    <ion-row class="ion-align-items-end">

                        <ion-col size="12" size-sm="auto">
                            <h6>{{ "components.errorOverview.filter.applications.label" | translate }}</h6>
                            <ion-button class="applicationFilterButton" fill="clear"
                                        id="select-applications">{{ ("components.errorOverview.filter.applications.selected." + (totalAmountOfSelectedApplications > 0 ? "some" : "all")) | translate:{totalAmountOfItems: totalAmountOfSelectedApplications} }}
                            </ion-button>
                            <ion-modal trigger="select-applications" #modal>
                                <ng-template>
                                    <app-searchable-select
                                        class="ion-page"
                                        titleKey="components.errorOverview.filter.applications.title"
                                        searchableProperty="friendlyName"
                                        fallbackSearchableProperty="name"
                                        trackProperty="id"
                                        [items]="applications"
                                        [form]="filterForm"
                                        [compareItemsMethod]="compareApplications"
                                        itemsControlName="applications"
                                        [maxSelectedItems]="maxSelectedApplications"
                                        [warningThreshold]="warningTresholdApplications"
                                        (selectionCompleted)="modal.dismiss()"
                                    />
                                </ng-template>
                            </ion-modal>
                        </ion-col>

                        <ion-col size="12" size-sm="auto" class="dateRangePickerSection">
                            <app-date-range-picker
                                [maxPeriodDifference]="maxPeriodDifference"
                                [form]="filterForm"
                                startControlName="startDate"
                                endControlName="endDate"
                                formGroupName="timePeriod">
                            </app-date-range-picker>
                        </ion-col>

                        <ion-col size="12" size-sm="auto" class="filterButtons">
                            <ion-button color="medium"
                                        (click)="clearFilter()">{{ "components.errorOverview.filter.buttons.reset" | translate }}
                            </ion-button>
                            <ion-button class="ion-margin-start" color="secondary"
                                        type="submit">{{ "components.errorOverview.filter.buttons.filter" | translate }}
                            </ion-button>
                        </ion-col>
                    </ion-row>
                </form>
            </ion-grid>
            @if (isLoadingErrors) {
                <app-error-card-skeleton-loading/>
                <app-error-card-skeleton-loading/>
                <app-error-card-skeleton-loading/>
                <ion-grid>
                    <ion-row class="ion-justify-content-center">
                        <ion-col size="auto">
                            <ion-skeleton-text class="loadingPaginator" [animated]="true"></ion-skeleton-text>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            } @else {
                @if (errorItems.length > 0) {
                    @for (errorItem of errorItems; track errorItem.id) {
                        <ng-container *ngComponentOutlet="getSummaryCard(errorItem); inputs: createInputs(errorItem)"/>
                    }
                    <ion-grid>
                        <ion-row class="ion-justify-content-center">
                            <ion-col size="auto">
                                <mat-paginator
                                    (page)="changePage($event)"
                                    [length]="totalAmountOfErrorItems"
                                    [pageSize]="pageSize"
                                    [showFirstLastButtons]="true"
                                    [hidePageSize]="true"
                                    [pageSizeOptions]="[]"
                                    [pageIndex]="currentPageIndex">
                                </mat-paginator>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                } @else {
                    <p class="ion-padding-start">{{ "components.errorOverview.noContentMessage" | translate }}</p>
                }
            }
        }
    </div>
</ion-content>
